export const cancelReasons = [
  { label: 'ORDER', value: 'ORDER' },
  { label: 'TICKET', value: 'TICKET' },
  { label: 'TAX EXEMPT', value: 'TAX_EXEMPT' },
];
export const status = [{ value: 'ACTIVE' }, { value: 'INACTIVE' }];
